/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Description1Inputs */

const id_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabunglah dengan beta tertutup kami untuk menguji aplikasi Android egdata.app sebelum rilis publik.`)
};

const ms_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai beta tertutup kami untuk menguji aplikasi Android egdata.app sebelum keluaran awam.`)
};

const da_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltag i vores lukkede beta for at teste egdata.app Android-appen før offentlig udgivelse.`)
};

const de_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehmen Sie an unserer geschlossenen Beta teil, um die egdata.app Android-App vor der öffentlichen Veröffentlichung zu testen.`)
};

const en_us2_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join our closed beta to test the egdata.app Android application before public release.`)
};

const es_es2_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a nuestra beta cerrada para probar la aplicación Android de egdata.app antes de su lanzamiento público.`)
};

const es_mx2_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a nuestra beta cerrada para probar la aplicación Android de egdata.app antes de su lanzamiento público.`)
};

const fil_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa aming closed beta upang subukan ang egdata.app Android application bago ang pampublikong release.`)
};

const fr_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez notre bêta fermée pour tester l'application Android egdata.app avant sa sortie publique.`)
};

const it_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partecipa alla nostra beta chiusa per testare l'applicazione Android egdata.app prima del rilascio pubblico.`)
};

const hu_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csatlakozz a zárt bétánkhoz, és teszteld az egdata.app Android alkalmazást a nyilvános megjelenés előtt.`)
};

const nl_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem deel aan onze gesloten bèta om de egdata.app Android-applicatie te testen voor de openbare release.`)
};

const no_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli med i vår lukkede beta for å teste egdata.app Android-applikasjonen før offentlig lansering.`)
};

const pl_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do naszej zamkniętej bety, aby przetestować aplikację egdata.app na Androida przed publicznym wydaniem.`)
};

const pt_br2_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participe do nosso beta fechado para testar o aplicativo egdata.app Android antes do lançamento público.`)
};

const pt_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junte-se à nossa beta fechada para testar a aplicação Android do egdata.app antes do lançamento público.`)
};

const ro_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alătură-te betei noastre închise pentru a testa aplicația Android egdata.app înainte de lansarea publică.`)
};

const fi_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liity suljettuun betaamme testataksesi egdata.app Android -sovellusta ennen julkista julkaisua.`)
};

const sv_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå med i vår slutna beta för att testa egdata.app Android-appen före publik release.`)
};

const vi_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham gia beta kín của chúng tôi để thử nghiệm ứng dụng Android egdata.app trước khi phát hành công khai.`)
};

const tr_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herkese açık sürümden önce egdata.app Android uygulamasını test etmek için kapalı betamıza katılın.`)
};

const cs_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojte se k naší uzavřené beta verzi a otestujte Android aplikaci egdata.app před veřejným vydáním.`)
};

const bg_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присъединете се към нашата затворена бета версия, за да тествате Android приложението egdata.app преди публичното му пускане.`)
};

const ru_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединяйтесь к нашему закрытому бета-тестированию, чтобы протестировать Android-приложение egdata.app до публичного релиза.`)
};

const uk_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднуйтеся до нашого закритого бета-тестування, щоб випробувати Android-застосунок egdata.app до публічного релізу.`)
};

const ar_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم إلى إصدارنا التجريبي المغلق لاختبار تطبيق Android egdata.app قبل الإصدار العام.`)
};

const hi_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे क्लोज्ड बीटा में शामिल हों।`)
};

const th_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมเบต้าปิดของเราเพื่อทดสอบแอปพลิเคชัน Android egdata.app ก่อนเผยแพร่สู่สาธารณะ`)
};

const ja_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開リリース前に egdata.app Android アプリケーションをテストするクローズドベータ版に参加。`)
};

const zh_cn2_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入我们的封闭测试，在公开发布之前试用 egdata.app Android应用程序。`)
};

const zh_hant1_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入我們的封閉測試，在公開發布之前試用 egdata.app Android應用程式。`)
};

const ko_misc_androidbeta_description1 = /** @type {(inputs: Misc_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개 출시 전에 egdata.app Android 애플리케이션을 테스트할 클로즈드 베타에 참여하세요.`)
};

/**
* | output |
* | --- |
* | "Join our closed beta to test the egdata.app Android application before public release." |
*
* @param {Misc_Androidbeta_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_description1 = /** @type {((inputs?: Misc_Androidbeta_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_description1(inputs)
	if (locale === "ms") return ms_misc_androidbeta_description1(inputs)
	if (locale === "da") return da_misc_androidbeta_description1(inputs)
	if (locale === "de") return de_misc_androidbeta_description1(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_description1(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_description1(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_description1(inputs)
	if (locale === "fil") return fil_misc_androidbeta_description1(inputs)
	if (locale === "fr") return fr_misc_androidbeta_description1(inputs)
	if (locale === "it") return it_misc_androidbeta_description1(inputs)
	if (locale === "hu") return hu_misc_androidbeta_description1(inputs)
	if (locale === "nl") return nl_misc_androidbeta_description1(inputs)
	if (locale === "no") return no_misc_androidbeta_description1(inputs)
	if (locale === "pl") return pl_misc_androidbeta_description1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_description1(inputs)
	if (locale === "pt") return pt_misc_androidbeta_description1(inputs)
	if (locale === "ro") return ro_misc_androidbeta_description1(inputs)
	if (locale === "fi") return fi_misc_androidbeta_description1(inputs)
	if (locale === "sv") return sv_misc_androidbeta_description1(inputs)
	if (locale === "vi") return vi_misc_androidbeta_description1(inputs)
	if (locale === "tr") return tr_misc_androidbeta_description1(inputs)
	if (locale === "cs") return cs_misc_androidbeta_description1(inputs)
	if (locale === "bg") return bg_misc_androidbeta_description1(inputs)
	if (locale === "ru") return ru_misc_androidbeta_description1(inputs)
	if (locale === "uk") return uk_misc_androidbeta_description1(inputs)
	if (locale === "ar") return ar_misc_androidbeta_description1(inputs)
	if (locale === "hi") return hi_misc_androidbeta_description1(inputs)
	if (locale === "th") return th_misc_androidbeta_description1(inputs)
	if (locale === "ja") return ja_misc_androidbeta_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_description1(inputs)
	return ko_misc_androidbeta_description1(inputs)
});
export { misc_androidbeta_description1 as "misc.androidBeta.description" }